export default __webpack_public_path__ + "static/media/4.c8d83962.jpg";